<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex md8 sm12>
        <v-carousel height="300">
          <v-carousel-item
            v-for="(i) in 3"
            :key="i"
          ></v-carousel-item>
        </v-carousel>
        <v-spacer></v-spacer>
        <div class="py-3">
          <v-card v-for="i in 8" :key="i" class="pa-2 mb-2" to="/post/123">
            <v-layout row>
              <v-flex md2 xs3>
                <v-img
                  src="https://cdn.vuetifyjs.com/images/cards/halcyon.png"
                  height="125px"
                  contain
                ></v-img>
              </v-flex>
              <v-flex md10 xs9>
                <v-card-title primary-title>
                  <div>
                    <div class="title">Halycon DaysHalycon DaysHalycon Days</div>
                    <div>Ellie Goulding</div>
                  </div>
                </v-card-title>
              </v-flex>
            </v-layout>
          </v-card>
        </div>
      </v-flex>
      <v-flex md4 sm12>
        <div class="pa-2 grey lighten-5" style="height:300px">ads</div>
      </v-flex>
      
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>